<template>
    <div class="container-tablist">
        <div class="tablist">
          <div v-for="tab in tabs" :key="tab" :class="[activeTab === tab.name ? 'active tab' : 'tab']" @click="changeTab(tab.name)">
            <span>{{ tab.title }}</span>
            <div class="tab-border-bottom"></div>
          </div>


          <!-- <div :class="[activeTab === 'orders' ? 'active tab' : 'tab']" @click="changeTab('orders')">
            <span>Уведомление</span>
            <div class="tab-border-bottom"></div>
          </div>
          <div :class="[activeTab === 'history' ? 'active tab' : 'tab']" @click="changeTab('history')">
            <span>История событий</span>
            <div class="tab-border-bottom"></div>
          </div> -->
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'TabList',
    props: {
        tabs: Array,
    },
    data() {
      return {
        activeTab: "",
      }
    },
    mounted() {
        this.activeTab = this.tabs[0].name;
    },
    methods: {

        // Выбор активной табы
        changeTab(tabName) {
            this.activeTab = tabName;
            this.$emit('selectTab', tabName)
        },
      
    }
  }
  </script>
  